/**
 * @author Ivan Toth.
 */
var DetailTableFpController = (function () {
    function DetailTableFpController(topic, settings, socket, $injector, env, $timeout) {
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.comp = 'fastpass';
        this.requiredCountrySearch = true;
        this.OPP_VERSION_3 = 3;
        this.tableName = 'Fast Pass';
        this.dc = { ds: 'FP-CN', countrySelected: '', fuzzySearch: '', opp: '', countryLine: [], pickList: [] };
        this.visible = false;
        this.expand = false;
        //this.dataSources = [{name: 'Cust No.', ds: 'FP-CN'},{name: 'BP Name', ds: 'FP-BP'},{name: 'Site No.', ds: 'FP-SN'},{name: 'S. Order', ds: 'FP-SO'}];
        this.dataSources = ['FP-CN', 'FP-BP', 'FP-SN', 'FP-SO'];
        this.stopSubmit = false;
        this.noValidCheck = true;
        this.govCheck = true;
        this.filterDisplay = false;
    }
    ;
    DetailTableFpController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableFpController.prototype.sendDupliCheck = function (opp) {
        if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
            /*this.stopSubmit = true;
            this.$timeout(() => {
                      this.stopSubmit = false;
                  }, 1000);*/
            this.dc.opp = opp;
            //this.dc.iot = this.settings.calcIot(this.topic.topic.gpp_valid[0].country);
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getFuzzyResults',
                    script: '/detail/eligibility/eligibility',
                    data: this.dc,
                    token: this.env.user.token,
                    bID: this.topic.topicBrowserID,
                    partial: true
                }
            });
        }
        ;
    };
    DetailTableFpController.prototype.toggleFilter = function () {
        this.filterDisplay = this.filterDisplay ? false : true;
    };
    DetailTableFpController.prototype.sendSONcheck = function (opp) {
        this.dc.pickList = [this.topic.topic.gpp_valid[0].salesorder];
        this.sendDupliCheck(opp);
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableFpController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.fastpass', value);
        this.expand = value;
    };
    DetailTableFpController.prototype.clearList = function () {
        this.dc.pickList = [];
    };
    DetailTableFpController.prototype.pushItem = function () {
        var _this = this;
        var dupli = false;
        angular.forEach(this.dc.pickList, function (iter) {
            if (iter === _this.toBeInserted) {
                dupli = true;
            }
        });
        if (!dupli) {
            this.dc.pickList.push(this.toBeInserted);
        }
        this.toBeInserted = '';
    };
    DetailTableFpController.prototype.countryChange = function () {
        return;
    };
    DetailTableFpController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout'];
    return DetailTableFpController;
}());
var DetailTableFpComponent = (function () {
    function DetailTableFpComponent() {
        this.templateUrl = 'detail-table-dc.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableFpController;
    }
    return DetailTableFpComponent;
}());
angular
    .module('application')
    .component('detailTableFp', new DetailTableFpComponent());

//# sourceMappingURL=detail.table.fp.component.js.map
